export enum AnalyticsEvents {
  FILTRO_COMUNICADOS = 'FILTRO_COMUNICADOS',
  FILTRO_USUARIOS = 'FILTRO_USUARIOS',
  FILTRO_DEALERS = 'FILTRO_DEALERS',
  FILTRO_SLIDES = 'FILTRO_SLIDES',
  FILTRO_ANUNCIOS = 'FILTRO_ANUNCIOS',
  FILTRO_NOTIFICACOES = 'FILTRO_NOTIFICACOES',
  FILTRO_NOTIFICACOES_GENERICAS = 'FILTRO_NOTIFICACOES_GENERICAS',
  CLONAR_PERMISSOES = 'CLONAR_PERMISSOES',
  CLONAR_PERMISSOES_CONCLUIDO = 'CLONAR_PERMISSOES_CONCLUIDO',
  CARD_ANUNCIO = 'CARD_ANUNCIO',
  VISUALIZAR_COMUNICADO = 'VISUALIZAR_COMUNICADO',
  VISUALIZAR_TODOS_COMUNICADOS = 'VISUALIZAR_TODOS_COMUNICADOS',
  VISUALIZAR_BIBLIOTECA = 'VISUALIZAR_BIBLIOTECA',
  REDES_SOCIAIS = 'REDES_SOCIAIS',
  POPOVER_ACOES_USUARIO = 'POPOVER_ACOES_USUARIO',
  EDICAO_USUARIO = 'EDICAO_USUARIO',
  ATIVAR_USUARIO = 'ATIVAR_USUARIO',
  INATIVAR_USUARIO = 'INATIVAR_USUARIO',
  AUSENCIA_USUARIO = 'AUSENCIA_USUARIO',
  EXPORTAR_USUARIOS = 'EXPORTAR_USUARIOS',
  IMPORTAR_USUARIOS_INICIO = 'IMPORTAR_USUARIOS_INICIO',
  IMPORTAR_USUARIOS_SUCESSO = 'IMPORTAR_USUARIOS_SUCESSO',
  IMPORTAR_USUARIOS_ERRO = 'IMPORTAR_USUARIOS_ERRO',
  NAVEGAR_IMPORTACAO_USUARIOS = 'NAVEGAR_IMPORTAR_USUARIOS',
  DADOS_COMPLEMENTARES_USUARIO = 'DADOS_COMPLEMENTARES_USUARIO',
  LIBERAR_ATIVACAO_ESPECIAL_USUARIO = 'LIBERAR_ATIVACAO_ESPECIAL_USUARIO',
  REMOVER_ATIVACAO_ESPECIAL_USUARIO = 'REMOVER_ATIVACAO_ESPECIAL_USUARIO',
  AUDITAR_USUARIO = 'AUDITAR_USUARIO',
  POPOVER_ACOES_GRUPO_USUARIOS = 'POPOVER_ACOES_GRUPO_USUARIOS',
  EDICAO_GRUPO_USUARIOS = 'EDICAO_GRUPO_USUARIOS',
  ATIVAR_GRUPO_USUARIOS = 'ATIVAR_GRUPO_USUARIOS',
  INATIVAR_GRUPO_USUARIOS = 'INATIVAR_GRUPO_USUARIOS',
  AUDITAR_GRUPO_USUARIOS = 'AUDITAR_GRUPO_USUARIOS',
  VER_DESTINATARIOS_GRUPO_USUARIOS = 'VER_DESTINATARIOS_GRUPO_USUARIOS',
  POPOVER_ACOES_DEALER = 'POPOVER_ACOES_DEALER',
  EDICAO_DEALERS = 'EDICAO_DEALERS',
  INATIVAR_DEALERS = 'INATIVAR_DEALERS',
  ATIVAR_DEALERS = 'ATIVAR_DEALERS',
  DADOS_COMPLEMENTARES_DEALER = 'DADOS_COMPLEMENTARES_DEALER',
  AUDITAR_DEALERS = 'AUDITAR_DEALERS',
  EXPORTAR_DEALERS = 'EXPORTAR_DEALERS',
  POPOVER_ACOES_GRUPO = 'POPOVER_ACOES_GRUPO',
  EDICAO_GRUPO = 'EDICAO_GRUPO',
  DADOS_COMPLEMENTARES_GRUPO = 'DADOS_COMPLEMENTARES_GRUPO',
  ATIVAR_GRUPO = 'ATIVAR_GRUPO',
  INATIVAR_GRUPO = 'INATIVAR_GRUPO',
  AUDITAR_GRUPO = 'AUDITAR_GRUPO',
  POPOVER_ACOES_SLIDE = 'POPOVER_ACOES_SLIDE',
  EDICAO_SLIDE = 'EDICAO_SLIDE',
  INATIVAR_SLIDE = 'INATIVAR_SLIDE',
  ATIVAR_SLIDE = 'ATIVAR_SLIDE',
  REMOVER_SLIDE = 'REMOVER_SLIDE',
  AUDITAR_SLIDE = 'AUDITAR_SLIDE',
  POPOVER_ACOES_ANUNCIO = 'POPOVER_ACOES_ANUNCIO',
  EDICAO_ANUNCIO = 'EDICAO_ANUNCIO',
  INATIVAR_ANUNCIO = 'INATIVAR_ANUNCIO',
  ATIVAR_ANUNCIO = 'ATIVAR_ANUNCIO',
  REMOVER_ANUNCIO = 'REMOVER_ANUNCIO',
  AUDITAR_ANUNCIO = 'AUDITAR_ANUNCIO',
  POPOVER_ACOES_NOTIFICACAO = 'POPOVER_ACOES_NOTIFICACAO',
  CRIAR_NOTIFICACAO_COM_MODELO = 'CRIAR_NOTIFICACAO_COM_MODELO',
  EDICAO_NOTIFICACAO = 'EDICAO_NOTIFICACAO',
  EDICAO_MODELO_NOTIFICACAO = 'EDICAO_MODELO_NOTIFICACAO',
  ENVIAR_NOTIFICACAO = 'ENVIAR_NOTIFICACAO',
  VISUALIZAR_NOTIFICACAO = 'VISUALIZAR_NOTIFICACAO',
  REMOVER_NOTIFICACAO = 'REMOVER_NOTIFICACAO',
  VISITAR_LINK_NOTIFICACAO = 'VISITAR_LINK_NOTIFICACAO',
  POPOVER_ACOES_COMUNICADO = 'POPOVER_ACOES_COMUNICADO',
  EDICAO_COMUNICADO = 'EDICAO_COMUNICADO',
  CRIAR_ERRATA_COMUNICADO = 'CRIAR_ERRATA_COMUNICADO',
  DASHBOARD_COMUNICADO = 'DASHBOARD_COMUNICADO',
  REMOVER_COMUNICADO = 'REMOVER_COMUNICADO',
  MARCAR_LIDO_COMUNICADO = 'MARCAR_LIDO_COMUNICADO',
  MARCAR_NAO_LIDO_COMUNICADO = 'MARCAR_NAO_LIDO_COMUNICADO',
  ARQUIVAR_COMUNICADO = 'ARQUIVAR_COMUNICADO',
  FAVORITAR_COMUNICADO = 'FAVORITAR_COMUNICADO',
  DESFAVORITAR_COMUNICADO = 'DESFAVORITAR_COMUNICADO',
  DESARQUIVAR_COMUNICADO = 'DESARQUIVAR_COMUNICADO',
  BUSCA_BIBLIOTECA_VIRTUAL = 'BUSCA_BIBLIOTECA_VIRTUAL',
  EXIBICAO_BIBLIOTECA_VIRTUAL = 'EXIBICAO_BIBLIOTECA_VIRTUAL',
  ALTERAR_PROPRIETARIO_BIBLIOTECA_VIRTUAL = 'ALTERAR_PROPRIETARIO_BIBLIOTECA_VIRTUAL',
  CONCEDER_ACESSO_BIBLIOTECA_VIRTUAL = 'CONCEDER_ACESSO_BIBLIOTECA_VIRTUAL',
  RENOMEAR_BIBLIOTECA_VIRTUAL = 'RENOMEAR_BIBLIOTECA_VIRTUAL',
  REMOVER_BIBLIOTECA_VIRTUAL = 'REMOVER_BIBLIOTECA_VIRTUAL',
  DOWNLOAD_BIBLIOTECA_VIRTUAL = 'DOWNLOAD_BIBLIOTECA_VIRTUAL',
  MOVER_BIBLIOTECA_VIRTUAL = 'MOVER_BIBLIOTECA_VIRTUAL',
  ATUALIZAR_DADOS_CADASTRAIS = 'ATUALIZAR_DADOS_CADASTRAIS',
  ATUALIZAR_SENHA = 'ATUALIZAR_SENHA',
  ATUALIZAR_NOTIFICACOES = 'ATUALIZAR_NOTIFICACOES'
}
